// extracted by mini-css-extract-plugin
export default {"buttons":"ConfigureCoe_buttons__lwdJE"};